import ApiService from '@/services/api.service';
import getters from '@/store/global';

const state = {
    init: {},
    initAnonymous: {},
    myBets: false,
    timeDelta: 0,
    errors: {}
};

getters['fetchInit'] = function(state) { return state.init }
getters['fetchTimeDelta'] = function(state) { return state.timeDelta }
getters['fetchMyBets'] = function(state) { return state.myBets }

const actions = {
    get(context) {
        return ApiService
            .get('init/')
            .then((response) => {
                context.commit('SET_ERROR', {});
                context.commit('SET_INIT', response.data);
                context.commit('SET_TIME_DELTA', response.data.server_time);
                context.commit('SET_MY_BETS', response.data.roulette_bets);
            })
            .catch(() => {
                throw new Error('Something goes wrong');
            });
    },
    setCounters(context, payload) {
        context.commit('SET_COUNTER', payload);
    },
    addRouletteGift(context, payload) {
        context.commit('ADD_ROULETTE_GIFT', payload);
    },
    removeRouletteGift(context) {
        context.commit('REMOVE_ROULETTE_GIFT');
    },
    setMyBets(context, payload) {
        context.commit('SET_MY_BETS', payload);
    }
};

const mutations = {
    SET_INIT(state, init) {
        state.init = init;
        state.errors = {};
    },
    SET_COUNTER(state, data) {
        if (!state.init.counters) {
            return;
        }
        if (data.increment) {
            state.init.counters[data.counter] += data.count;
            if (state.init.counters[data.counter] < 0) {
                state.init.counters[data.counter] = 0;
            }
        } else {
            state.init.counters[data.counter] = data.count;
        }
    },
    SET_TIME_DELTA(state, serverTime) {
        state.timeDelta = +new Date() - serverTime*1000;
    },
    ADD_ROULETTE_GIFT(state, gift) {
        state.init.roulette_gifts.unshift(gift);
    },
    REMOVE_ROULETTE_GIFT(state) {
        state.init.roulette_gifts.pop();
    },
    SET_MY_BETS(state, bets) {
        state.myBets = bets;
    },
    SET_ERROR(state, errors) {
        state.errors = errors;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
